/**
 * Error types for middleware client
 */
export class MiddlewareClientError extends Error {
    code;
    statusCode;
    details;
    constructor(message, code, statusCode, details) {
        super(message);
        this.code = code;
        this.statusCode = statusCode;
        this.details = details;
        this.name = 'MiddlewareClientError';
    }
}
export class AuthenticationError extends MiddlewareClientError {
    constructor(message, details) {
        super(message, 'AUTHENTICATION_ERROR', 401, details);
        this.name = 'AuthenticationError';
    }
}
export class NetworkError extends MiddlewareClientError {
    constructor(message, details) {
        super(message, 'NETWORK_ERROR', undefined, details);
        this.name = 'NetworkError';
    }
}
export class ValidationError extends MiddlewareClientError {
    constructor(message, details) {
        super(message, 'VALIDATION_ERROR', 400, details);
        this.name = 'ValidationError';
    }
}
export class NotFoundError extends MiddlewareClientError {
    constructor(resource, identifier) {
        const message = identifier
            ? `${resource} '${identifier}' not found`
            : `${resource} not found`;
        super(message, 'NOT_FOUND', 404, { resource, identifier });
        this.name = 'NotFoundError';
    }
}
export class RateLimitError extends MiddlewareClientError {
    constructor(retryAfter) {
        super('Rate limit exceeded', 'RATE_LIMIT_ERROR', 429, { retryAfter });
        this.name = 'RateLimitError';
    }
}
export class ServiceUnavailableError extends MiddlewareClientError {
    constructor(message = 'Service temporarily unavailable') {
        super(message, 'SERVICE_UNAVAILABLE', 503);
        this.name = 'ServiceUnavailableError';
    }
}
//# sourceMappingURL=errors.js.map